module.exports = require("core-js/es/promise");